import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';

export default {
    acquirerName: {
        type: FILTER_TYPES.text,
    },
    amount: {
        type: FILTER_TYPES.numeric,
    },
    baseAmount: {
        type: FILTER_TYPES.numeric,
    },
    bin: {
        type: FILTER_TYPES.numeric,
    },
    createdTime: {
        type: FILTER_TYPES.datetime,
    },
    currency: {
        type: FILTER_TYPES.text,
    },
    customerId: {
        type: FILTER_TYPES.text,
    },
    dccUsdMarkup: {
        type: FILTER_TYPES.numeric,
    },
    description: {
        type: FILTER_TYPES.text,
    },
    gatewayAccountId: {
        type: FILTER_TYPES.text,
    },
    gatewayName: {
        type: FILTER_TYPES.text,
    },
    gatewayTransactionId: {
        type: FILTER_TYPES.text,
    },
    hadDiscrepancy: {
        type: FILTER_TYPES.boolean,
    },
    has3ds: {
        type: FILTER_TYPES.boolean,
    },
    hasDcc: {
        type: FILTER_TYPES.boolean,
    },
    id: {
        type: FILTER_TYPES.text,
    },
    invoiceId: {
        type: FILTER_TYPES.text,
    },
    isDisputed: {
        type: FILTER_TYPES.boolean,
    },
    isRebill: {
        type: FILTER_TYPES.boolean,
    },
    isReconciled: {
        type: FILTER_TYPES.boolean,
    },
    isRetry: {
        type: FILTER_TYPES.boolean,
    },
    method: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            // path: 'Transaction/method/enum', // TODO Transaction/method?
            path: 'Method/enum',
        },
    },
    orderId: {
        type: FILTER_TYPES.text,
    },
    organizationId: {
        type: FILTER_TYPES.text,
    },
    parentTransactionId: {
        type: FILTER_TYPES.text,
    },
    paymentCardId: {
        type: FILTER_TYPES.text,
    },
    planIds: {
        type: FILTER_TYPES.text,
    },
    processedTime: {
        type: FILTER_TYPES.datetime,
    },
    quoteAmount: {
        type: FILTER_TYPES.numeric,
    },
    rebillNumber: {
        type: FILTER_TYPES.text,
    },
    result: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            path: 'Transaction/result/enum',
        },
    },
    retriedTransactionId: {
        type: FILTER_TYPES.text,
    },
    retriesResult: {
        type: FILTER_TYPES.enum,
    },
    retryNumber: {
        type: FILTER_TYPES.numeric,
    },
    riskScore: {
        type: FILTER_TYPES.numeric,
    },
    scheduledTime: {
        type: FILTER_TYPES.datetime,
    },
    status: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            path: 'Transaction/status/enum',
        },
    },
    subscriptionId: {
        type: FILTER_TYPES.text,
    },
    translatedCurrency: {
        type: FILTER_TYPES.text,
    },
    type: {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.definitions,
            path: 'Transaction/type/enum',
        },
    },
    updatedTime: {
        type: FILTER_TYPES.datetime,
    },
    velocity: {
        type: FILTER_TYPES.numeric,
    },
    websiteId: {
        type: FILTER_TYPES.text,
    },
    websiteName: {
        type: FILTER_TYPES.text,
    },
    isProcessedOutside: {
        type: FILTER_TYPES.boolean,
    },
    // risk meta data
    riskMetadata: {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/ipAddress': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/isProxy': {
        type: FILTER_TYPES.boolean,
    },
    'riskMetadata/isVpn': {
        type: FILTER_TYPES.boolean,
    },
    'riskMetadata/isTor': {
        type: FILTER_TYPES.boolean,
    },
    'riskMetadata/isHosting': {
        type: FILTER_TYPES.boolean,
    },
    'riskMetadata/vpnServiceName': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/isp': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/country': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/city': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/postalCode': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/latitude': {
        type: FILTER_TYPES.numeric,
    },
    'riskMetadata/longitude': {
        type: FILTER_TYPES.numeric,
    },
    'riskMetadata/accuracyRadius': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/timeZone': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/fingerprint': {
        type: FILTER_TYPES.text,
    },
    'riskMetadata/distance': {
        type: FILTER_TYPES.numeric,
    },
    // gateway response
    gatewayResponseCode: {
        type: FILTER_TYPES.text,
    },
    gatewayResponseOriginalCode: {
        type: FILTER_TYPES.text,
    },
    gatewayResponseOriginalMessage: {
        type: FILTER_TYPES.text,
    },
    avsGatewayResponseOriginalCode: {
        type: FILTER_TYPES.text,
    },
    avsGatewayResponseOriginalMessage: {
        type: FILTER_TYPES.text,
    },
    cvsGatewayResponseOriginalCode: {
        type: FILTER_TYPES.text,
    },
    cvsGatewayResponseOriginalMessage: {
        type: FILTER_TYPES.text,
    },
    // lead sources
    'leadSource/source': {
        type: FILTER_TYPES.text,
    },
    'leadSource/medium': {
        type: FILTER_TYPES.text,
    },
    'leadSource/campaign': {
        type: FILTER_TYPES.text,
    },
    'leadSource/content': {
        type: FILTER_TYPES.text,
    },
    'leadSource/term': {
        type: FILTER_TYPES.text,
    },
    'leadSource/affiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/subAffiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/salesAgent': {
        type: FILTER_TYPES.text,
    },
    'leadSource/amount': {
        type: FILTER_TYPES.numeric,
    },
    'leadSource/path': {
        type: FILTER_TYPES.text,
    },
    'leadSource/ipAddress': {
        type: FILTER_TYPES.text,
    },
    'leadSource/clickId': {
        type: FILTER_TYPES.text,
    },
    'leadSource/createdTime': {
        type: FILTER_TYPES.datetime,
    },
    'leadSource/updatedTime': {
        type: FILTER_TYPES.datetime,
    },
    'billingAddress/firstName': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/lastName': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/address': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/address2': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/organization': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/city': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/region': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/country': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/postalCode': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/email': {
        type: FILTER_TYPES.text,
    },
    'billingAddress/phoneNumber': {
        type: FILTER_TYPES.text,
    },
    hasBumpOffer: {
        type: FILTER_TYPES.boolean,
    },
    'bumpOffer/outcome': {
        type: FILTER_TYPES.select,
        options: {
            source: FILTER_SOURCE_TYPES.enum,
            enum: [
                'unknown',
                'selected',
                'rejected',
            ],
        },
    },
};
